import type { DataSourceEntity } from '@unifyapps/defs/types/dataSource';
import DataSourceHelper from '../../../helper/DataSourceHelper';
import { DependencyFlowStatus } from '../types';

/**
 * when the app is initially loaded, we need to fetch the initial page load data sources, so we push them to staging env
 * where they will also add their dependencies to staging env if they have any
 */
export const getInitialDataSourceDependencyFlow = (
  dataSources?: Record<string, DataSourceEntity | undefined>,
) => {
  const automaticPageLoad = dataSources
    ? DataSourceHelper.getAutomaticPageLoadDataSources(dataSources)
    : [];

  return automaticPageLoad.reduce((acc, ds) => {
    acc[ds.id] = {
      status: DependencyFlowStatus.Staging,
    };
    return acc;
  }, {});
};
